import React, {useContext, useEffect} from "react";
import Timeline, {TimelineStep} from "./Timeline";
import {addDays, formatCurrency, formatDate, formatTime} from "../../utils/helpers";
import Button from "../Form/Button/Button";
import checkIcon from "../../assets/images/check-mint-circle.svg"
import {customerDataContext} from "../../contexts/CustomerDataProvider";
import {useUnifiedAnalytics} from "../../contexts/AnalyticsWrapper";

/** @import {ConfirmationStepProps} from './ConfirmationStepTypes' */

const constructDateTime = (/** @type {Date} */ date, /** @type {string | undefined} */ time) => {
    // closure time is passed through graphQL as a separate string to prevent value being lost during conversion from
    // c# DateTime
    const timeList = time?.match(/\d{2}/g);
    const [hours, minutes] = timeList ? [parseInt(timeList[0], 10), parseInt(timeList[1], 10)] : [0, 0];
    return new Date(new Date(date).setHours(hours, minutes))
}

function ConfirmationStep(/** @type {ConfirmationStepProps} */ {account, multipleMaturingAccounts, instruction}) {

    const analytics = useUnifiedAnalytics();
    const navigateToDashboard = () => {
        analytics.trackAnalyticsClickEvent(
            'return to your dashboard',
            '/',
            'bottom',
            'dashboard',
            'cta',
            {},
            'link click',
            'navigation|click|return to dashboard',
            ''
        );
        window.location.href = "/"
    }

    const giveInstructionOnAnotherAccount = () => {
        analytics.trackAnalyticsClickEvent(
            "give instruction for another account",
            "/maturity-instruction",
            "confirm page bottom",
            "fixed rate saver",
            "maturity",
            {},
            "click",
            "fixed rate saver|click|maturity",
            "maturity"
        );
        window.location.href = "/maturity-instruction"
    }

    useEffect(() => {
        analytics.trackAnalyticsPageEvent('generic load',{},'','Investec-Save-secure|page_load|ConfirmationStep');
    }, []);

    const data = useContext(customerDataContext);
    const product = data?.data?.customer.products.find(product => product.id === instruction?.options.rolloverAccountProductId);

    return <>
        <div className={'maturity3__flex-row maturity3__flex-row--left-align maturity3__no-wrap title-box'}>
            <img className={"maturity3__inline-icon"} src={checkIcon} alt={'check icon'}/>
            <h1 className={"text__title"}>We’ve received your instruction</h1>
        </div>
        <Timeline>
            <TimelineStep title={`${formatDate(account.maturity?.maturityWindowCloseDate)} at ${formatTime(constructDateTime(new Date(), account.maturity?.maturityWindowCloseTime))}`}
                          content={
                              <div>
                                  <b>We’ll lock in your renewal instruction</b>
                                  <p>You can change your mind
                                      until {formatTime(constructDateTime(new Date(), account.maturity?.maturityWindowCloseTime))}.</p>
                              </div>}/>
            <TimelineStep title={`${formatDate(account.maturity?.maturityDate)}`}
                          content={
                              <div>
                                  <b>Your new {product?.name} opens and your funding window begins</b>
                                  <p>You’ll have seven days to top up your new account if you want to, up to a total
                                      balance of {formatCurrency(account.product.maxWithdrawalLimit, false)}. Remember to
                                      use your new account details.</p>
                                  <p>We’ll also send you an email confirmation.</p>
                              </div>}/>
            {/* TODO: avoid magic number, pull FW duration through from query */}
            <TimelineStep title={`${formatDate(addDays(account.maturity?.maturityDate || new Date(), 7))} at 23:59`}
                          content={
                              <div>
                                  <b>Your funding window closes</b>
                                  <p>You won’t be able to add any more money from this point, and your balance will
                                      be locked in until your next maturity date.</p>
                              </div>}/>
        </Timeline>
        <div className={'maturity3__flex-row maturity3__flex-row--left-align'}>
            {multipleMaturingAccounts &&
                <Button size='med'
                        customClassNames={["navigation-button"]}
                        label="Give instruction for another account"
                        onClick={() => giveInstructionOnAnotherAccount()}
                />}
            <Button size='med'
                    label={"Return to your dashboard"}
                    onClick={navigateToDashboard}
                    customClassNames={["navigation-button__back"]}
            />
        </div>
    </>
}
export default ConfirmationStep